<!-- DYNAMIC SHOWCASE -->
@if (dynamic) {
  <div [ngStyle]="getShowcaseStyles()" [ngClass]="showcase.className">
    @if (showcase.title) {
      <div fxLayoutAlign="start end">
        <span
          class="ag-pa-sm"
          [ngStyle]="{ background: $safeNavigationMigration(showcase?.titleBackground) }"
          style="font-size: 1.1em; font-weight: 500"
        >
          {{ showcase.title }}
        </span>
      </div>
    }
    <div #swipe class="swiper">
      <div class="swiper-wrapper">
        @if ((documents$ | async).length === 0) {
          <div
            class="text-center"
            style="width: 100%; position: relative; height: 250px; vertical-align: middle; top: 45%"
          >
            @if (loading) {
              <div>
                <mat-spinner
                  diameter="24"
                  style="display: inline-block; position: relative; margin-top: 5em"
                ></mat-spinner>
              </div>
            }
          </div>
        }
        @for (doc of documents$ | async; track doc) {
          <div class="pointer swiper-slide">
            <div
              class="jacketarturl pointer slick-img"
              tabindex="0"
              (agInteract)="goToFullRecord(doc)"
            >
              <img
                [alt]="doc.title"
                [src]="doc.jacketArt.small"
                [title]="doc.title"
                class="max-height-100"
                onerror="this.onerror=null;this.alt='Image not available';this.src='https\:\/\/www5.auto-graphics.com/v6assets/no-image-foundlrg.png?local'"
              />
            </div>
            <div class="captions" tabindex="0" (keyup.enter)="goToFullRecord(doc)">
              <div class="mat-body-strong ellipsis">{{ doc.title }}</div>
              <div>
                <div class="ellipsis">{{ doc.author }}</div>
                <div class="ellipsis">{{ doc.publisher }}</div>
                <div class="ellipsis">{{ doc.format_Long }}</div>
                @if (doc.pubYear) {
                  <div class="ellipsis">
                    @for (date of doc.pubYear; track date) {
                      <span>
                        {{ date }}
                      </span>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
      <div #swipePrev class="swiper-button-prev"></div>
      <div #swipeNext class="swiper-button-next"></div>
    </div>
  </div>
}
<!-- STATIC SHOWCASE -->
@if (!dynamic) {
  <div
    class="showcaseDiv static list-showcase"
    [ngStyle]="getShowcaseStyles()"
    [ngClass]="$safeNavigationMigration(showcase?.className)"
  >
    @if (showcase.title) {
      <div fxLayoutAlign="start end">
        <span
          class="ag-pa-sm"
          [ngStyle]="{ background: showcase.titleBackground }"
          style="font-size: 1.1em; font-weight: 500"
        >
          {{ showcase.title }}
        </span>
      </div>
    }
    @if (loading) {
      <div
        class="text-center"
        style="width: 100%; position: relative; height: 250px; vertical-align: middle; top: 45%"
      >
        <mat-spinner
          style="display: inline-block; position: relative; margin-top: 5em"
          diameter="24"
        ></mat-spinner>
      </div>
    }
    <div #swipe class="swiper">
      <div class="swiper-wrapper">
        @for (item of listItems$ | async; track item) {
          <div class="pointer swiper-slide">
            <div
              class="jacketarturl pointer slick-img"
              tabindex="0"
              (agInteract)="goToFullRecordList(item)"
            >
              <img
                [alt]="item.title"
                [src]="item.jacketArt.small"
                [title]="item.title"
                class="max-height-100"
                onerror="this.onerror=null;this.alt='Image not available';this.src='https\:\/\/www5.auto-graphics.com/v6assets/no-image-foundlrg.png?local'"
              />
            </div>
            <div class="captions" tabindex="0" (keyup.enter)="goToFullRecordList(item)">
              <div
                class="mat-body-strong ellipsis"
                tabindex="0"
                (agInteract)="goToFullRecordList(item)"
              >
                {{ item.title }}
              </div>
              <div>
                <div class="ellipsis">{{ item.author }}</div>
                <div class="ellipsis">{{ item.publisher }}</div>
                @if (item.pubYear !== '') {
                  <div class="ellipsis">
                    {{ item.pubYear }}
                  </div>
                }
                @if (item.formatType !== '') {
                  <div class="ellipsis">
                    {{ item.formatType }}
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
      <div #swipePrev class="swiper-button-prev"></div>
      <div #swipeNext class="swiper-button-next"></div>
    </div>
  </div>
}
<!-- display message for static showcase -->
@if ((message$ | async) && !loading) {
  <div class="text-center">
    <h4>{{ message$ | async }}</h4>
  </div>
}
